import React, {useState} from "react"
import {Form, Input, InputNumber, message, Modal, Spin} from "antd"
import {decMemberDiamond, getMemberDiamond} from "../../../../../api/clubMemberList"
import {useClubMemberContext} from "../../../store/useClubMemberContext"

const ClubMemberEditDiamond = ({memberId}) => {

    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [newDiamond, setNewDiamond] = useState(0)
    const [form] = Form.useForm()

    const {fetchClubMemberList} = useClubMemberContext()

    const fetchDiamond = async () => {
        setIsLoading(true)
        await getMemberDiamond(memberId).then((res) => {
            form.setFieldValue('diamond', res.count)
        }).catch(err => {
            message.error(`获取钻石数失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const handleOk = async () => {
        setIsLoading(true)
        await decMemberDiamond(memberId,newDiamond,form.getFieldValue('reason')).then((res) => {
            if (res.status) {
                message.success('修改成功')
                setIsShow(false)
                return
            }
            message.error(`修改失败：${res.detail}`)
        }).catch(err => {
            message.error(`修改失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
            fetchClubMemberList()
        })

    }

    const handleClick = async () => {
        setIsShow(true)
        form.resetFields()
        await fetchDiamond()
    }

    const handleCancel = () => {
        setIsShow(false)
    }

    const items = [
        {
            label: '钻石数',
            name: 'diamond',
            children: (<Input disabled/>),
            rules: []
        },
        {
            label: '扣减钻石数',
            name: 'newDiamond',
            children: (<div style={{display: "flex", flexDirection: "row"}}>
                <InputNumber
                    style={{width: '100%'}}
                    onChange={(value) => {
                        setNewDiamond(value)
                    }}
                    placeholder={"请输入钻石数"}
                    controls={false}
                />

            </div>),
            rules: [
                {required: true, message: '请输入钻石数'}
            ]
        },
        {
            label: '说明',
            name: 'reason',
            children: (
                <Input placeholder={"请输入说明"}/>
            ),
            rules: [
                {required: true, message: '请输入说明'}
            ]
        }
    ]

    return (
        <div>
            <div onClick={handleClick}>修改钻石</div>
            <Modal
                open={isShow}
                onCancel={handleCancel}
                onOk={form.submit}
                confirmLoading={isLoading}
                title={"修改钻石"}
                destroyOnClose
            >
                <Spin spinning={isLoading}>
                    <Form
                        style={{padding: 16}}
                        labelCol={{span: 6}}
                        wrapperCol={{span: 18}}
                        form={form}
                        onFinish={handleOk}
                    >
                        {items.map(item => {
                            return (<Form.Item label={item.label} name={item.name} key={item.name}
                                               rules={item.rules.length > 0 ? item.rules : []}>
                                {item.children}
                            </Form.Item>)
                        })}
                    </Form>
                </Spin>
            </Modal>
        </div>
    )
}

export default ClubMemberEditDiamond


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberEdit/component/ClubMemberEditDiamond.js